export default {
  BT_HDP: "핸디캡",
  BT_OU: "오버/언더",
  BT_ML: "머니라인",
  BT_1X2: "1X2",
  BT_1X2HDP: "3방식 핸디캡",
  BT_CS: "정확한 득점",
  BT_OE: "홀수/짝수",
  BT_DC: "더블 찬스",
  BT_HTFT: "전반전 경기/전후반경기",
  BT_FGLG: "첫 골 /마지막 골",
  BT_TG: "총 득점",
  BT_OR: "승자 예상 배팅",
  BT_ORZ: "승자 예상 배팅",
  BT_ODD: "홀수",
  BT_EVEN: "짝수",

  BT_ANB: "어웨이 노 베팅",
  BT_BS: "양 팀 득점/한 팀 득점/득점 없음",
  BT_CL: "클린 시트",
  BT_DNB: "무승부 시 베팅 무효",
  BT_DNB: "전반전 무승부 시 베팅 무효",
  BT_HNB: "홈 노 베팅",
  BT_TWTN: "완봉승",

  BT_HDPH: "전반전 핸디캡",
  BT_OUH: "전반전 오버/언더",
  BT_MLH: "전반전 머니라인",
  BT_1X2H: "전반전 1X2",
  BT_1X2HDPH: "전반전 3방식 핸디캡",
  BT_CSH: "전반전 정확한 득점",
  BT_OEH: "전반전 홀수/짝수",
  BT_DCH: "전반전 더블 찬스",
  BT_FGLGH: "전반전 첫 골 /마지막 골",
  BT_TGH: "전반전 총 득점",

  TB_HDP: "풀타임 핸디캡",
  TB_OU: "풀타임 오버/언더",
  TB_1X2: "풀타임 1X2",
  TB_OE: "전후반경기 홀수/짝수",
  TB_HDPH: "전반전 핸디캡",
  TB_OUH: "전반전 오버/언더",
  TB_1X2H: "전반전 1X2",
  TB_OEH: "전반전 홀수/짝수",

  BT_HDPOU: "핸디캡&오버/언더",
  BT_PARLAY: "믹스 팔레이",
  BT_FT: "전후반경기",
  BT_1H: "전반전",
  BT_2H: "후반전",

  BT_FG: "첫 득점",
  BT_LG: "마지막 득점",
  BT_HFG: "홈팀첫골",
  BT_AFG: "원정팀첫골",
  BT_HLG: "홈팀마지막골",
  BT_ALG: "원정팀마지막골",
  BT_NG: "노 골",
  BT_HY: "홈 팀 예스",
  BT_HN: "홈 팀 노",
  BT_AY: "원정팀 예스",
  BT_AN: "원정팀 노",
  BT_H: "홈팀",
  BT_A: "원정팀",
  BT_D: "무승부",
  BT_HD_DC: "홈 혹은 무승부",
  BT_HA_DC: "홈 혹은 원정",
  BT_DA_DC: "원정팀 혹은 무승부",
  BT_HH: "홈/홈",
  BT_HD: "홈/무승부",
  BT_HA: "홈/원정팀",
  BT_DH: "무승부/홈",
  BT_DD: "무승부/무승부",
  BT_DA: "무승부/원정팀",
  BT_AH: "원정팀/홈",
  BT_AD: "원정팀/무승부",
  BT_AA: "원정팀/원정팀",

  BT_Y: "예스",
  BT_N: "노",

  BT_LIVE: "라이브",
  BT_HT: "H.TIME",
  BT_DELAYED: "지연",
  BT_PEN: "PEN",

  BT_FT1: "풀타임.1",
  BT_FT2: "풀타임.2",
  BT_FTX: "풀타임.X",

  TC_FT1: "1",
  TC_FT2: "2",
  TC_FTX: "X",

  BT_HT1: "전반전.1",
  BT_HT2: "전반전.2",
  BT_HTX: "전반전.X",

  F5_INN_HDP: "F5 INN. HDP",
  F5_INN_OU: "F5 INN. O/U",

  BS_HDP: "풀타임 핸디캡",
  BS_HDPH: "전반전 핸디캡",
  BS_OU: "풀타임 오버/언더",
  BS_OUH: "전반전 오버/언더",
  BS_OE: "전후반경기 홀수/짝수",
  BS_OEH: "전반전 홀수/짝수",
  BS_1X2: "풀타임 1X2",
  BS_1X2H: "전반전 1X2",
  BS_ML: "전후반경기 머니라인",
  BS_MLH: "전반전 머니라인",
  BS_1X2HDP: "전후반경기 3방식 핸디캡",
  BS_1X2HDPH: "전반전 3방식 핸디캡",
  BS_CS: "전후반경기 정확한 득점",
  BS_CSH: "전반전 정확한 득점",
  BS_DC: "전후반경기 더블 찬스",
  BS_DCH: "전반전 더블 찬스",
  BS_FGLG: "전후반경기 첫 골 /마지막 골",
  BS_FGLGH: "전반전 첫 골 /마지막 골",
  BS_TG: "전후반경기 총 득점",
  BS_TGH: "전반전 총 득점",
  BS_ANB: "어웨이 노 베팅",
  BS_HTFT: "전반전 경기/전후반경기",
  BS_BS: "양 팀 득점/한 팀 득점/득점 없음",
  BS_CL: "클린 시트",
  BS_DNB: "무승부 시 베팅 무효",
  BS_DNBH: "전반전 무승부 시 베팅 무효",
  BS_HNB: "홈 노 베팅",
  BS_TWTN: "완봉승",
  BS_OR: "승자 예상 배팅",
  BS_ORZ: "승자 예상 배팅",

}